"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Monument = void 0;
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const DiscardCards_1 = require("../../deferredActions/DiscardCards");
class Monument {
    constructor() {
        this.name = 'Monument';
        this.description = 'As an additional cost, discard 5 cards to claim this milestone';
    }
    getScore(player) {
        return player.cardsInHand.length;
    }
    canClaim(player) {
        return this.getScore(player) >= 5;
    }
    static discardCards(player) {
        player.game.defer(new DiscardCards_1.DiscardCards(player, 5));
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            player.game.log('${0} discarded 5 cards', (b) => b.player(player));
            return undefined;
        }));
    }
}
exports.Monument = Monument;
//# sourceMappingURL=Monument.js.map